import { render, staticRenderFns } from "./LandingPageInsurersComponent.vue?vue&type=template&id=77fe6949&scoped=true&"
import script from "./LandingPageInsurersComponent.vue?vue&type=script&lang=js&"
export * from "./LandingPageInsurersComponent.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageInsurersComponent.vue?vue&type=style&index=0&id=77fe6949&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fe6949",
  null
  
)

export default component.exports